(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (customElements.get("announcement-bar-component") == undefined) {
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.closeAnnouncementButton = this.querySelector("[data-close-announcement]");
        this.announcementBarSlider = this.querySelector("[data-announcement-bar]");
        this.announcementHasSlides =
          this.announcementBarSlider?.querySelectorAll(".announcement-bar__message").length > 1;

        if (AnnouncementBar.getCookie("announcement") == "closed") {
          this.remove();
        } else {
          this.style.opacity = 1;
          this.style.visibility = "visible";
        }

        document.addEventListener("DOMContentLoaded", () => {
          this.initAnnouncementBarSlider();
          this.closeAnnouncementButton?.addEventListener("click", this.closeAnnouncementBar.bind(this));
        });
      }

      closeAnnouncementBar(e) {
        e.preventDefault();
        e.stopPropagation();

        this.remove();
        AnnouncementBar.setCookie("announcement", "closed", 1);
      }

      initAnnouncementBarSlider() {
        if (this.announcementHasSlides && !this.announcementBarSlider.classList.contains("slick-initialized")) {
          let showArrows;
          this.announcementBarSlider.dataset.arrows == "true" || this.announcementBarSlider.dataset.arrows == true
            ? (showArrows = true)
            : (showArrows = false);
          $(this.announcementBarSlider).slick({
            infinite: true,
            vertical: false,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: showArrows,
            autoplay: true,
            autoplaySpeed: 3000,
            nextArrow:
              '<button type="button" class="slick-next" aria-label="Next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="Previous"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
          });
        }
      }

      static setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }

      static getCookie(cname) {
        const name = cname + "=";
        const ca = document.cookie.split(";");

        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === " ") {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }

        return "";
      }
    }

    customElements.define("announcement-bar-component", AnnouncementBar);

    // Antes: listener de scroll NAO-passivo que a cada evento lia innerHeight e
    // getBoundingClientRect e logo depois escrevia classList — ler/escrever/ler forca
    // layout sincrono. Medido em 11/09/2026 (Moto G Power, CPU 4x lenta): 1 disparo na
    // carga (a chamada inicial, dentro da long task de 934 ms do tema) e ~266 disparos
    // numa rolagem de 12 wheels. IntersectionObserver responde exatamente a mesma
    // pergunta -- "esta no viewport?" -- sem custo de layout e sem listener de scroll.
    // A condicao antiga (top < viewportHeight && bottom >= 0) e interseccao com o
    // viewport, que e isIntersecting com root default e threshold 0.
    const elementToAnimate = document.querySelector(".announcement-bar");
    if (elementToAnimate) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          entries[i].target.classList.toggle("active-screen", entries[i].isIntersecting);
        }
      }).observe(elementToAnimate);
    }
  }

  if (window.announcementClosed) {
    document.querySelector(".announcement-bar").remove();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aside-media-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const dotWrappers = document.querySelectorAll(".dot-wrapper");

    dotWrappers.forEach((dotWrapper) => {
      const tooltip = document.querySelector(`.tooltip[data-tooltip-index="${dotWrapper.dataset.dotIndex}"]`);
      const dot = dotWrapper.querySelector(".dot");

      const popperInstance = Popper.createPopper(dot, tooltip, {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 8],
            },
          },
          {
            name: "preventOverflow",
            options: {
              padding: 8,
            },
          },
        ],
      });

      function show() {
        tooltip.setAttribute("data-show", "");

        // We need to tell Popper to update the tooltip position
        // after we show the tooltip, otherwise it will be incorrect
        popperInstance.update();
      }

      function hide(e) {
        if (tooltip.contains(e.relatedTarget)) return;
        tooltip.removeAttribute("data-show");
      }

      const showEvents = ["mouseenter", "focus"];
      const hideEvents = ["mouseleave", "blur"];

      showEvents.forEach((event) => {
        dot.addEventListener(event, show);
      });

      hideEvents.forEach((event) => {
        dot.addEventListener(event, hide);
        tooltip.addEventListener(event, hide);
      });

      dot.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        window.open(dot.dataset.url, "_blank");
      });

      tooltip.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        window.open(dot.dataset.url, "_blank");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banners"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const scrollableContainers = document.querySelectorAll(
      ".collection-banners-section .collection-banner-icons__inner"
    );

    scrollableContainers.forEach((scrollableContainer) => {
      scrollableContainer.addEventListener("scroll", function (e) {
        const maxLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);
        const scrollOffset = 10;

        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-left",
          scrollableContainer.scrollLeft > scrollOffset
        );
        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-right",
          scrollableContainer.scrollLeft < maxLeft - scrollOffset
        );
      });

      scrollableContainer.dispatchEvent(new Event("scroll"));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slideshow"] && !Shopify.designMode) return;
  try {
    
  // Mantém a cor da divisória inferior sincronizada com o slide ativo do slideshow.
  class SlideshowDivider extends HTMLElement {
    connectedCallback() {
      this.slideshow = document.getElementById(this.dataset.slideshow);
      this.divider = this.querySelector("[data-bottom-wavy-divider]");
      if (!this.slideshow || !this.divider) return;

      this.fallbackColor = this.divider.style.getPropertyValue("--divider-color");
      this.sync = this.sync.bind(this);

      // O slick reescreve as classes dos slides a cada transição, e pode inicializar
      // depois deste elemento, então observar o DOM é mais confiável que ouvir seus eventos.
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.slideshow, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });

      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    sync() {
      const current =
        this.slideshow.querySelector(".item.slick-current") || this.slideshow.querySelector(".item");

      this.divider.style.setProperty(
        "--divider-color",
        (current && current.getAttribute("data-slide-bg")) || this.fallbackColor
      );
    }
  }

  if (!customElements.get("slideshow-divider")) {
    customElements.define("slideshow-divider", SlideshowDivider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("click", (event) => {
    const option = event.target.closest(".comparacao-mobile-option");

    if (option) {
      const dropdown = option.closest(".comparacao-mobile-dropdown");
      const table = option.closest(".comparacao-table");

      if (table) {
        table.dataset.activeCol = option.dataset.targetCol;
      }

      if (dropdown) {
        dropdown.removeAttribute("open");
      }

      return;
    }

    document.querySelectorAll(".comparacao-mobile-dropdown[open]").forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.removeAttribute("open");
      }
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    document.querySelectorAll(".comparacao-mobile-dropdown[open]").forEach((dropdown) => {
      dropdown.removeAttribute("open");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compra-rapida"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const root = document.getElementById("compra-rapida");
    if (!root) return;
    // evita bind duplicado se o script rodar mais de uma vez (ex.: editor de temas)
    if (root.dataset.crInit === "1") return;
    root.dataset.crInit = "1";

    const formatarMoeda = (centavos) => {
      if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
        return Shopify.formatMoney(centavos, window.money_format);
      }
      return "R$ " + (centavos / 100).toFixed(2).replace(".", ",");
    };

    /* ---------- Config ---------- */
    const subDesconto = parseFloat(root.dataset.assinaturaDesconto) || 0;
    const sellingPlanId = root.dataset.sellingPlanId ? Number(root.dataset.sellingPlanId) : null;
    const singular = root.dataset.unidadeSingular || "pote";
    const plural = root.dataset.unidadePlural || "potes";
    const textoSeuKit = root.dataset.textoSeuKit || "";

    /* Faixas do desconto progressivo por quantidade */
    const steps = Array.from(root.querySelectorAll(".cr-faixa-step"))
      .map((el) => ({
        qty: parseInt(el.dataset.stepQty, 10) || 0,
        discount: parseFloat(el.dataset.discount) || 0,
      }))
      .sort((a, b) => a.qty - b.qty);

    /* ---------- Elementos ---------- */
    const previewEl = root.querySelector("[data-cr-preview]");
    const legendEl = root.querySelector("[data-cr-kit-legend]");
    const subtotalEl = root.querySelector("[data-subtotal]");
    const summaryQtyEl = root.querySelector("[data-summary-qty]");
    const discountLineEl = root.querySelector("[data-discount-line]");
    const discountEl = discountLineEl ? discountLineEl.querySelector("[data-discount]") : null;
    const discountPctEl = root.querySelector("[data-discount-pct]");
    const totalKitEl = root.querySelector("[data-total-kit]");
    const clearBtn = root.querySelector("[data-cr-clear]");
    const buyTotalEl = root.querySelector("[data-buy-total]");
    const subCompareEl = root.querySelector(".cr-subscribe-compare");
    const subTotalEl = root.querySelector(".cr-subscribe-total");
    const buyBtn = root.querySelector("[compra-rapida-add]");
    const subscribeBtn = root.querySelector("[data-cr-subscribe]");
    const errorEl = root.querySelector(".cr-error");
    const priceBlocks = Array.from(root.querySelectorAll("[data-item-price]"));

    /* ---------- Helpers ---------- */
    function currentStep(qty) {
      let step = null;
      steps.forEach((s) => {
        if (qty >= s.qty) step = s;
      });
      return step;
    }

    function getContainers() {
      return Array.from(root.querySelectorAll("cart-update-compra-rapida"));
    }

    function getLinhas() {
      return getContainers().map((c) => {
        const input = c.querySelector(".compra-rapida-input-qty");
        return {
          qty: input ? parseInt(input.value, 10) || 0 : 0,
          price: parseInt(c.dataset.price, 10) || parseInt(input && input.dataset.price, 10) || 0,
        };
      });
    }

    function getState() {
      let qty = 0;
      let subtotal = 0;
      getLinhas().forEach((l) => {
        qty += l.qty;
        subtotal += l.price * l.qty;
      });
      return { qty: qty, subtotal: subtotal };
    }

    /* Soma do mesmo jeito que o carrinho soma: cada percentual arredonda no
       preço de UMA unidade e só depois multiplica pela quantidade. Aplicar o
       percentual sobre o subtotal fechado dá diferença de centavos contra o
       carrinho — 3 x R$ 179,90 com 15% fechava R$ 458,74 aqui e R$ 458,76 lá,
       porque lá cada unidade custa os R$ 152,92 já arredondados (o mesmo valor
       que o card exibe). Os percentuais entram em cascata, na ordem do array. */
    function somaUnitaria(percentuais) {
      return getLinhas().reduce((total, l) => {
        const unit = percentuais.reduce((valor, pct) => Math.round((valor * (100 - pct)) / 100), l.price);
        return total + unit * l.qty;
      }, 0);
    }

    function updatePreview(qty) {
      if (!previewEl) return;
      previewEl.innerHTML = "";
      let count = 0;
      getContainers().forEach((c) => {
        const input = c.querySelector(".compra-rapida-input-qty");
        const q = input ? parseInt(input.value, 10) || 0 : 0;
        if (q <= 0) return;
        count++;
        const item = document.createElement("div");
        item.className = "cr-preview-item";
        item.style.background = c.dataset.bgColor;
        const thumb = c.dataset.thumb;
        item.innerHTML =
          (thumb ? '<img src="' + thumb + '" alt="' + (c.dataset.name || "") + '" loading="lazy">' : "") +
          '<span class="cr-preview-qty">' +
          q +
          "</span>";
        previewEl.appendChild(item);
      });
      previewEl.hidden = count === 0;
      if (legendEl) {
        legendEl.hidden = count === 0;
        legendEl.textContent = textoSeuKit + " (" + qty + (qty === 1 ? " item)" : " itens)");
      }
    }

    /* Preço dos cards: exibe o valor com o desconto da faixa que seria atingida
       ao adicionar mais 1 item (a contagem soma potes iguais ou diferentes). */
    function updateCardPrices(qty) {
      if (!steps.length) return;
      const proximo = currentStep(qty + 1);
      const pct = proximo ? proximo.discount : 0;

      priceBlocks.forEach((block) => {
        const base = parseInt(block.dataset.basePrice, 10) || 0;
        const finalEl = block.querySelector("[data-price-final]");
        const originalEl = block.querySelector("[data-price-original]");
        const compareEl = block.querySelector("[data-price-compare]");
        if (!finalEl) return;

        if (pct > 0 && base > 0) {
          finalEl.textContent = formatarMoeda(Math.round((base * (100 - pct)) / 100));
          if (originalEl) {
            originalEl.textContent = formatarMoeda(base);
            originalEl.hidden = false;
          }
          // evita dois preços riscados lado a lado
          if (compareEl) compareEl.hidden = true;
          block.classList.add("tem-desconto-projetado");
        } else {
          finalEl.textContent = formatarMoeda(base);
          if (originalEl) originalEl.hidden = true;
          if (compareEl) compareEl.hidden = false;
          block.classList.remove("tem-desconto-projetado");
        }
      });
    }

    function updateSummary(state) {
      /* O desconto da faixa já aparecia no preço dos cards; agora ele também
         entra no resumo e no total, senão a linha "Desconto" contradiria o
         valor cobrado no botão. */
      const faixa = currentStep(state.qty);
      const discPct = faixa ? faixa.discount : 0;
      const totalCents = somaUnitaria([discPct]);
      const descontoCents = state.subtotal - totalCents;

      if (subtotalEl) subtotalEl.textContent = formatarMoeda(state.subtotal);
      if (summaryQtyEl) {
        summaryQtyEl.textContent = state.qty > 0 ? "(" + state.qty + " " + (state.qty === 1 ? singular : plural) + ")" : "";
      }
      if (discountLineEl && discountEl) {
        discountLineEl.hidden = descontoCents <= 0;
        discountEl.textContent = "- " + formatarMoeda(descontoCents);
        if (discountPctEl) discountPctEl.textContent = "(" + discPct + "% OFF)";
      }
      if (totalKitEl) totalKitEl.textContent = formatarMoeda(totalCents);
      if (buyTotalEl) buyTotalEl.textContent = formatarMoeda(totalCents);

      // assinatura: mesmo arredondamento por unidade, com o desconto da
      // assinatura em cima do preço que já saiu com a faixa
      const subCents = somaUnitaria([discPct, subDesconto]);
      if (subCompareEl) subCompareEl.textContent = formatarMoeda(state.subtotal);
      if (subTotalEl) subTotalEl.textContent = formatarMoeda(subCents);
    }

    function calcTotal() {
      const state = getState();
      updatePreview(state.qty);
      updateCardPrices(state.qty);
      updateSummary(state);

      const disabled = state.qty <= 0;
      [buyBtn, subscribeBtn, clearBtn].forEach((b) => {
        if (b) b.disabled = disabled;
      });
      if (errorEl) errorEl.hidden = true;
    }

    /* O accordion por coleção virou abas: quem troca de coleção agora é o
       <tab-nav> (assets/tab-nav.js), inclusive pelo teclado. Só sobra aqui a
       ponte com o editor de temas — selecionar o bloco de uma coleção na
       barra lateral tem que abrir a aba dela, senão o lojista clica no bloco
       e nada acontece na tela. */
    const abasCR = root.querySelector("tab-nav");
    if (abasCR) {
      document.addEventListener("shopify:block:select", function (e) {
        const aba = e.target.closest(".tab-nav__tab");
        if (!aba || !abasCR.contains(aba) || typeof abasCR.select !== "function") return;
        abasCR.select(Array.from(abasCR.querySelectorAll(".tab-nav__tab")).indexOf(aba));
      });
    }

    root.querySelectorAll("[data-cr-plus]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        const input = this.previousElementSibling;
        const container = this.closest("cart-update-compra-rapida");

        if (!input || !container) return;

        const estoque = parseInt(container.getAttribute("data-inventory")) || 999;
        let atual = parseInt(input.value) || 0;

        if (atual < estoque) {
          input.value = atual + 1;
          input.classList.remove("compra-rapida-zero");

          const minus = container.querySelector(".compra-rapida-minus");
          if (minus) {
            minus.classList.remove("compra-rapida-item-not-added");
          }

          calcTotal();
        }
      });
    });

    root.querySelectorAll("[data-cr-minus]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        const input = this.nextElementSibling;
        const container = this.closest("cart-update-compra-rapida");

        if (!input || !container) return;

        let atual = parseInt(input.value) || 0;

        if (atual > 0) {
          input.value = atual - 1;

          if (atual - 1 === 0) {
            input.classList.add("compra-rapida-zero");
            this.classList.add("compra-rapida-item-not-added");
          }

          calcTotal();
        }
      });
    });

    function buildItems(subscription) {
      const items = [];
      getContainers().forEach(function (container) {
        const id = container.getAttribute("data-variant");
        const input = container.querySelector(".compra-rapida-input-qty");
        const qtd = input ? parseInt(input.value, 10) || 0 : 0;
        if (qtd > 0 && id) {
          const item = { id: Number(id), quantity: qtd };
          if (subscription && sellingPlanId) item.selling_plan = sellingPlanId;
          items.push(item);
        }
      });
      return items;
    }

    function resetInputs() {
      getContainers().forEach(function (container) {
        const input = container.querySelector(".compra-rapida-input-qty");
        const minus = container.querySelector(".compra-rapida-minus");
        if (input) {
          input.value = 0;
          input.classList.add("compra-rapida-zero");
        }
        if (minus) minus.classList.add("compra-rapida-item-not-added");
      });
    }

    /* Limpar seleção: reaproveita o mesmo resetInputs do pós-checkout e devolve
       o módulo ao estado inicial (resumo, mini-carrinho, barra e CTAs). */
    if (clearBtn) {
      clearBtn.addEventListener("click", function (e) {
        e.preventDefault();
        resetInputs();
        calcTotal();
      });
    }

    async function adicionarAoCarrinho(subscription, btn) {
      const items = buildItems(subscription);
      if (!items.length) return;

      btn.classList.add("is-loading");
      btn.disabled = true;
      if (errorEl) errorEl.hidden = true;

      try {
        const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || "Não foi possível adicionar ao carrinho.");

        document.body.classList.remove("compra-rapida-aberto");
        document.body.classList.add("cart-sidebar-show");

        fetch(window.Shopify.routes.root + "cart.js")
          .then((r) => r.json())
          .then((cart) => {
            document.querySelectorAll("[data-cart-count]").forEach((el) => {
              el.textContent = cart.item_count;
            });
            if (typeof window.updateCart === "function") window.updateCart(cart);
          });

        resetInputs();
        calcTotal();
      } catch (error) {
        console.error("Erro:", error);
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      } finally {
        btn.classList.remove("is-loading");
        btn.disabled = false;
        calcTotal();
      }
    }

    if (buyBtn)
      buyBtn.addEventListener("click", function () {
        adicionarAoCarrinho(false, this);
      });
    if (subscribeBtn)
      subscribeBtn.addEventListener("click", function () {
        adicionarAoCarrinho(true, this);
      });

    calcTotal();

    function abrirCompraRapida() {
      document.body.classList.add("compra-rapida-aberto");
    }

    // Delegação: qualquer link com #compra-rapida no href (mesmo adicionado depois)
    document.addEventListener("click", function (e) {
      const link = e.target.closest('a[href*="#compra-rapida"]');
      const btn = e.target.closest("#compra-rapida-trigger");

      if (btn && !link) {
        e.preventDefault();
        abrirCompraRapida();
        return;
      }
      if (!link) return;

      const href = (link.getAttribute("href") || "").trim();
      const mesmaPagina = href.charAt(0) === "#" || link.pathname === window.location.pathname;

      if (mesmaPagina) {
        e.preventDefault();
        abrirCompraRapida();
      }
    });

    // Redirect de outra página: chega com #compra-rapida na URL
    if (window.location.hash === "#compra-rapida") {
      abrirCompraRapida();
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    window.addEventListener("hashchange", function () {
      if (window.location.hash === "#compra-rapida") {
        abrirCompraRapida();
      }
    });

    document.querySelectorAll("[fechar-compra-rapida]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        document.body.classList.remove("compra-rapida-aberto");
      });
    });

    const overlay = document.querySelector(".background-overlay");

    if (overlay) {
      overlay.addEventListener(
        "click",
        function (e) {
          document.body.classList.remove("compra-rapida-aberto");
        },
        true
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq_lp"] && !Shopify.designMode) return;
  try {
    
class AccordionDetails extends HTMLDetailsElement {
  constructor() {
    super();

    this._open = this.hasAttribute('open');
    this.summaryElement = this.querySelector('summary');
    this.contentElement = this.querySelector('summary + *');
    this.setAttribute('aria-expanded', this._open ? 'true' : 'false');

    this.summaryElement.addEventListener('click', this.onSummaryClick.bind(this));

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', () => {
        if (this.designModeActive) this.open = true;
      });
      this.addEventListener('shopify:block:deselect', () => {
        if (this.designModeActive) this.open = false;
      });
    }
  }

  get designModeActive() {
    return true;
  }

  get controlledElement() {
    return this.closest('accordions-details');
  }

  static get observedAttributes() {
    return ['open'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.setAttribute('aria-expanded', newValue === '' ? 'true' : 'false');
    }
  }

  get open() {
    return this._open;
  }

  set open(value) {
    if (value !== this._open) {
      this._open = value;

      if (this.isConnected) {
        this.transition(value);
      }
      else {
        value ? this.setAttribute('open', '') : this.removeAttribute('open');
      }
    }

    this.setAttribute('aria-expanded', value ? 'true' : 'false');
    this.dispatchEventHandler();
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.open = !this.open;
  }

  close() {
    this._open = false;
    this.transition(false);
  }

  async transition(value) {
    this.style.overflow = 'hidden';

    if (value) {
      this.setAttribute('open', '');

      await Motion.timeline([
        [this, { height: [`${this.summaryElement.clientHeight}px`, `${this.scrollHeight}px`] }, { duration: 0.25, easing: 'ease' }],
        [this.contentElement, { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] }, { duration: 0.15, at: '-0.1' }]
      ]).finished;
    }
    else {
      await Motion.timeline([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [this, { height: [`${this.clientHeight}px`, `${this.summaryElement.clientHeight}px`] }, { duration: 0.25, at: '<', easing: 'ease' }]
      ]).finished;

      this.removeAttribute('open');
    }

    this.style.height = 'auto';
    this.style.overflow = 'visible';
  }

  dispatchEventHandler() {
    (this.controlledElement ?? this).dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { current: this, open: this.open } }));
  }
}
customElements.define('accordion-details', AccordionDetails, { extends: 'details' });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-toolbar-mobile"]) return;
  try {
    
  const buttons = document.querySelectorAll("[data-bar-content]");
  if (buttons.length) {
    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        if (event.target.nextSibling.classList.contains("show")) {
          event.target.nextSibling.classList.remove("show");
          document.querySelector("body")?.classList.remove("show-sidebar-content");
        } else {
          event.target.nextSibling.classList.add("show");
          document.querySelector("body")?.classList.add("show-sidebar-content");
        }
      });
    });
    document.querySelectorAll("[data-close-content-sidebar]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.target.closest(".bottom-bar--content").classList.remove("show");
        document.querySelector("body")?.classList.remove("show-sidebar-content");
      });
    });
  }
  $("body").addClass("sticky-toolbar-mobile");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
  class StickyHeaderMobile extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector(".section-header-mobile");
      this.headerIsAlwaysSticky =
        this.getAttribute("data-sticky-type") === "always" ||
        this.getAttribute("data-sticky-type") === "reduce-logo-size";
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add("shopify-section-header-sticky");
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector("predictive-search");

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add("scrolled-past-header");
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add("scrolled-past-header");
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove("scrolled-past-header");
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
      this.header.classList.remove("shopify-section-header-show");
      this.header.style.top = "";
    }

    reveal() {
      const headerMultiSite = document.querySelector(".section-header-nav-multi-site");
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-sticky", "shopify-section-header-show", "animate");
      this.header.classList.remove("shopify-section-header-hidden");
      if (headerMultiSite) {
        const height = headerMultiSite.offsetHeight;
        this.header.style.top = `${height}px`;
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        "shopify-section-header-hidden",
        "shopify-section-header-show",
        "shopify-section-header-sticky",
        "animate"
      );
      this.header.style.top = "";
    }
  }

  customElements.define("sticky-header-mobile", StickyHeaderMobile);

  document.querySelectorAll("[data-mobile-menu]").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.body.classList.toggle("menu_open");
    });
  });

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function renderLogoMobile() {
    if ($("[data-menu-tab]").length > 0) {
      $(document).on("click", "[data-menu-tab] li", (event) => {
        var active = $(event.currentTarget).data("load-page"),
          href = $(event.currentTarget).attr("href");

        $.cookie("page-url", active, {
          expires: 1,
          path: "/",
        });
      });

      var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
        pageUrl = $.cookie("page-url"),
        menuTabItem,
        logoTabItem,
        menuItem;

      if (window.location.pathname.indexOf("/pages/") !== -1 && window.page_active && window.page_active != pageUrl) {
        setCookie("page-url", window.page_active, 1);
        pageUrl = window.page_active;
      }

      if (pageUrl != null) {
        menuTabItem = $(`[data-load-page="${pageUrl}"]`);
        logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
        menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
      } else {
        menuTabItem = $("[data-load-page].is-active");
        logoTabItem = $("[data-load-logo-page].first");
        menuItem = $("[data-load-menu-page].is-active");
      }

      var menuTab = menuTabItem.closest("[data-menu-tab]");

      menuTab.find("[data-load-page]").not(menuTabItem).removeClass("is-active");
      logoTabItem.siblings().removeClass("is-active");
      menuItem.siblings().removeClass("is-active");
      if (pageUrl != "") {
        logoTabItem.addClass("is-active");
        menuTabItem.addClass("is-active");
        menuItem.addClass("is-active");
      } else {
        $("[data-load-page]:nth-child(1)").addClass("is-active");
        $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
        $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
      }

      const header = menuTabItem.closest(".header");

      if (header && window.innerWidth < 1025) {
        if (window.location.pathname.indexOf("/pages/") !== -1 && window.page_active && window.page_active != pageUrl) {
          setCookie("page-url", window.page_active, 1);
          pageUrl = window.page_active;
        }

        const logoMobile = $(".header-mobile .header__heading-link");
        const logDesktop = header.find(".header__heading-link.is-active");

        if (logDesktop.data("logo-mobile") == undefined) {
          logoMobile.find("img").addClass("logo-show");
          return;
        } else {
          logoMobile.html(
            `<img src="${logDesktop.data("logo-mobile")}" alt="${logDesktop.data(
              "logo-mobile-alt"
            )}" style="max-width: ${logoMobile.data("logo-width")}px; height: auto"/>`
          );

          logoMobile.find("img").addClass("logo-show");
          if (pageUrl != "" && pageUrl != null) logoMobile.attr("href", pageUrl);
        }
      }
    }
  }

  renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
  var sticky = document.getElementsByTagName("sticky-header")[0].querySelector(".header-nav-hamburger");
  if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector(".section-header-navigation");
        this.headerIsAlwaysSticky = this.getAttribute("data-sticky-type");
        this.headerBounds = {};
        this.setHeaderHeight();
        window.matchMedia("(max-width: 990px)").addEventListener("change", this.setHeaderHeight.bind(this));
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add("shopify-section-header-sticky");
        }
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector("predictive-search");
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.addEventListener("load", this.checkLoadPosition.bind(this));
        window.addEventListener("scroll", this.onScrollHandler, false);
        this.createObserver();
      }
      setHeaderHeight() {
        document.documentElement.style.setProperty("--header-height", `${this.header.offsetHeight}px`);
      }
      disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.removeEventListener("load", this.checkLoadPosition);
        window.removeEventListener("scroll", this.onScrollHandler);
      }
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }
      checkLoadPosition() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

        if (headerGr[0].classList.contains("shopify-section-header-sticky")) {
          if (scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains("scrolled-past-header")) {
            this.header.classList.add("shopify-section-header-hidden");
          }
        } else {
          headerGr.forEach((item) => {
            if (item.classList.contains("shopify-section-header-sticky")) {
              const itemPrev = item.previousElementSibling;
              const itemPrevHeight = itemPrev.offsetHeight;
              const itemPrevTop = itemPrev.offsetTop;

              if (scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains("scrolled-past-header")) {
                if (this.headerIsAlwaysSticky != "always") {
                  this.header.classList.add("shopify-section-header-hidden");
                }
              }
            }
          });
        }
      }
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          this.header.classList.add("scrolled-past-header");
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add("scrolled-past-header");
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove("scrolled-past-header");
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
      }
      hide() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === "always") {
            this.header.classList.add("shopify-section-header-sticky");
            return;
          } else {
            this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
            this.header.classList.remove("shopify-section-header-show");
            document.querySelector("body")?.classList.add("section-header-is-hidden");
          }
        }
        this.closeMenuDisclosure();
      }
      reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === "always") {
            this.header.classList.add("shopify-section-header-sticky", "animate");
            return;
          } else {
            this.header.classList.add("shopify-section-header-sticky", "shopify-section-header-show", "animate");
            this.header.classList.remove("shopify-section-header-hidden");
            document.querySelector("body")?.classList.remove("section-header-is-hidden");
          }
        }
      }
      reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === "always") {
            this.header.classList.add("shopify-section-header-sticky", "animate");
            return;
          } else {
            this.header.classList.remove(
              "shopify-section-header-hidden",
              "shopify-section-header-show",
              "shopify-section-header-sticky",
              "animate"
            );
            document.querySelector("body")?.classList.remove("section-header-is-hidden");
          }
        }
      }
      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll("details-disclosure");
        this.disclosures.forEach((disclosure) => disclosure.close());
      }
    }
    customElements.define("sticky-header", StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
        this.header = document.querySelector('.section-header-navigation');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        }

        setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
        }

        onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');

            if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
            } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            document.body.classList.remove('scrolled-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
        this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
            }
        }

        closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-top-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const scrollableContainers = document.querySelectorAll(".top-bar-menu");

    scrollableContainers.forEach((scrollableContainer) => {
      scrollableContainer.addEventListener("scroll", function (e) {
        const maxLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);
        const scrollOffset = 10;

        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-left",
          scrollableContainer.scrollLeft > scrollOffset
        );
        scrollableContainer.parentElement.classList.toggle(
          "can-scroll-right",
          scrollableContainer.scrollLeft < maxLeft - scrollOffset
        );
      });

      let isDragging = false;
      let startX;
      let scrollLeft;

      scrollableContainer.addEventListener("mousedown", function (e) {
        isDragging = true;
        startX = e.pageX - scrollableContainer.offsetLeft;
        scrollLeft = scrollableContainer.scrollLeft;
        scrollableContainer.style.cursor = "grabbing";
        scrollableContainer.style.userSelect = "none";
        e.preventDefault();
      });

      scrollableContainer.addEventListener("mousemove", function (e) {
        if (!isDragging) return;
        const x = e.pageX - scrollableContainer.offsetLeft;
        const walk = x - startX;
        scrollableContainer.scrollLeft = scrollLeft - walk;
      });

      function stopDragging() {
        isDragging = false;
        scrollableContainer.style.cursor = "";
        scrollableContainer.style.userSelect = "";
      }

      scrollableContainer.addEventListener("mouseup", stopDragging);
      scrollableContainer.addEventListener("mouseleave", stopDragging);

      scrollableContainer.dispatchEvent(new Event("scroll"));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-claim"] && !Shopify.designMode) return;
  try {
    
  /* DELEGADO NO DOCUMENT (20/Ago/2026). Antes isto fazia
       trigger.addEventListener("click", open)
     direto no nó, e o modal parava de abrir depois da primeira troca de sabor: o
     botão [data-lab-open] é renderizado DENTRO da .productView
     (snippets/product-page.liquid:859, bloco 'eurofins'), e o assets/gd-variant-swap.js
     substitui esse nó inteiro por AJAX quando o cliente clica num .tp-variant-link.
     O listener ia embora com o nó antigo, e não havia onde reaplicá-lo: este bloco de
     script é concatenado pelo Shopify e roda UMA vez por página, não por section.
     Delegação resolve de vez — sobrevive ao swap e a qualquer outro re-render. */
  (function () {
    var MODAL_SELECTOR = ".lp-modal";
    var lastFocus = null;

    /* O aria-controls do botão na PDP aponta pra um section.id de OUTRO template
       (markup colado), então ele pode não existir aqui — daí o fallback no primeiro
       .lp-modal da página, que é o comportamento que este script já tinha. */
    function modalFor(trigger) {
      var id = trigger.getAttribute("aria-controls");
      return (
        (id && document.getElementById(id)) ||
        document.querySelector(MODAL_SELECTOR)
      );
    }

    function openModal(modal) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("lp-modal-open");

      var closeBtn = modal.querySelector(".lp-modal__close");
      if (closeBtn) closeBtn.focus();
    }

    function closeModal(modal) {
      modal.hidden = true;
      document.body.classList.remove("lp-modal-open");

      /* isConnected: se o foco anterior era o botão da .productView e houve troca de
         sabor com o modal aberto, aquele nó não está mais no documento. */
      if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === "function") {
        lastFocus.focus();
      }
      lastFocus = null;
    }

    function openModalOnPage() {
      return document.querySelector(MODAL_SELECTOR + ":not([hidden])");
    }

    document.addEventListener("click", function (event) {
      if (!event.target.closest) return;

      var trigger = event.target.closest("[data-lab-open]");
      if (trigger) {
        var target = modalFor(trigger);
        if (!target) return;

        event.preventDefault();
        openModal(target);
        return;
      }

      var current = openModalOnPage();
      if (!current) return;

      var panel = current.querySelector(".lp-modal__panel");
      var clickedOutsidePanel =
        current.contains(event.target) && panel && !panel.contains(event.target);

      if (event.target.closest("[data-lab-close]") || clickedOutsidePanel) {
        closeModal(current);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;

      var current = openModalOnPage();
      if (!current) return;

      event.preventDefault();
      closeModal(current);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mesmo defeito do announcement-bar, e pior: o getBoundingClientRect de cada .marquee
    // ficava intercalado com o classList do anterior, entao cada elemento forcava um
    // layout novo, a cada evento de scroll. Um observer so atende todos.
    const elementsToAnimateMarquee = document.querySelectorAll(".marquee");

    if (elementsToAnimateMarquee.length) {
      const observador = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          entries[i].target.classList.toggle("active-screen", entries[i].isIntersecting);
        }
      });
      elementsToAnimateMarquee.forEach(function (element) {
        observador.observe(element);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monte-seu-kit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const root = document.getElementById("monte-seu-kit");
    if (!root) return;
    // evita bind duplicado se o script rodar mais de uma vez (ex.: editor de temas)
    if (root.dataset.mskInit === "1") return;
    root.dataset.mskInit = "1";

    const formatarMoeda = (centavos) => {
      if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
        return Shopify.formatMoney(centavos, window.money_format);
      }
      return "R$ " + (centavos / 100).toFixed(2).replace(".", ",");
    };

    /* ---------- Config ---------- */
    const precoBase = parseInt(root.dataset.precoBase, 10) || 0;
    const subDesconto = parseFloat(root.dataset.assinaturaDesconto) || 0;
    const sellingPlanId = root.dataset.sellingPlanId ? Number(root.dataset.sellingPlanId) : null;
    const brindeVariantId = root.dataset.brindeVariantId ? Number(root.dataset.brindeVariantId) : null;
    const instigadorMax = root.dataset.instigadorMax || "";

    const singular = root.dataset.unidadeSingular;
    const plural = root.dataset.unidadePlural;
    const brindeImage = root.dataset.brindeImage || "";
    const textoSeuKit = root.dataset.textoSeuKit || "";

    /* Faixas lidas do DOM da progressbar */
    const steps = Array.from(root.querySelectorAll(".cr-pb-step"))
      .map((el) => ({
        el: el,
        qty: parseInt(el.dataset.stepQty, 10),
        discount: parseFloat(el.dataset.discount) || 0,
        freeShipping: el.dataset.freeShipping === "true",
        brinde: el.dataset.brinde === "true",
        position: parseFloat(el.style.getPropertyValue("--position")) || 0,
      }))
      .sort((a, b) => a.qty - b.qty);

    /* ---------- Elementos ---------- */
    const pbFill = root.querySelector(".cr-pb-fill");
    const pbDot = root.querySelector(".cr-pb-dot");
    const detailTiers = Array.from(root.querySelectorAll(".cr-pb-details .cr-pb-tier"));
    const instigadorEl = root.querySelector("[data-instigador]");
    const previewEl = root.querySelector("[data-cr-preview]");
    const legendEl = root.querySelector("[data-cr-kit-legend]");
    const subtotalEl = root.querySelector("[data-subtotal]");
    const summaryQtyEl = root.querySelector("[data-summary-qty]");
    const discountLineEl = root.querySelector("[data-discount-line]");
    const discountEl = discountLineEl.querySelector("[data-discount]");
    const discountPctEl = root.querySelector("[data-discount-pct]");
    const totalKitEl = root.querySelector("[data-total-kit]");
    const clearBtn = root.querySelector("[data-cr-clear]");
    const buyTotalEl = root.querySelector("[data-buy-total]");
    const subCompareEl = root.querySelector(".cr-subscribe-compare");
    const subTotalEl = root.querySelector(".cr-subscribe-total");
    const buyBtn = root.querySelector("[monte-seu-kit-add]");
    const subscribeBtn = root.querySelector("[data-cr-subscribe]");
    const errorEl = root.querySelector(".cr-error");
    const priceBlocks = Array.from(root.querySelectorAll("[data-item-price]"));

    /* ---------- Helpers ---------- */
    function getContainers() {
      return Array.from(root.querySelectorAll("cart-update-monte-seu-kit"));
    }

    function getLinhas() {
      return getContainers().map((c) => {
        const input = c.querySelector(".monte-seu-kit-input-qty");
        return {
          qty: input ? parseInt(input.value, 10) || 0 : 0,
          price: parseInt(c.dataset.price, 10) || parseInt(input && input.dataset.price, 10) || 0,
        };
      });
    }

    function getState() {
      let qty = 0;
      let subtotal = 0;
      getLinhas().forEach((l) => {
        qty += l.qty;
        subtotal += l.price * l.qty;
      });
      return { qty: qty, subtotal: subtotal };
    }

    /* Soma do mesmo jeito que o carrinho soma: cada percentual arredonda no
       preço de UMA unidade e só depois multiplica pela quantidade. Aplicar o
       percentual sobre o subtotal fechado dá diferença de centavos contra o
       carrinho — 3 x R$ 179,90 com 15% fechava R$ 458,74 aqui e R$ 458,76 lá,
       porque lá cada unidade custa os R$ 152,92 já arredondados (o mesmo valor
       que o card exibe). Os percentuais entram em cascata, na ordem do array. */
    function somaUnitaria(percentuais) {
      return getLinhas().reduce((total, l) => {
        const unit = percentuais.reduce((valor, pct) => Math.round((valor * (100 - pct)) / 100), l.price);
        return total + unit * l.qty;
      }, 0);
    }

    function hasBrinde(qty) {
      return steps.some((s) => s.qty <= qty && s.brinde);
    }

    function currentStep(qty) {
      let step = null;
      steps.forEach((s) => {
        if (qty >= s.qty) step = s;
      });
      return step;
    }

    function nextStep(qty) {
      return steps.find((s) => s.qty > qty) || null;
    }

    function nextBetterStep(qty) {
      const cur = currentStep(qty);
      const curDisc = cur ? cur.discount : 0;
      const curFrete = cur ? cur.freeShipping : false;
      return steps.find((s) => s.qty > qty && (s.discount > curDisc || (s.freeShipping && !curFrete))) || nextStep(qty);
    }

    function percentForQty(qty) {
      if (!steps.length || qty <= 0) return 0;
      const first = steps[0];
      const last = steps[steps.length - 1];
      if (qty <= first.qty) return first.qty === 0 ? first.position : (qty / first.qty) * first.position;
      if (qty >= last.qty) return last.position;
      for (let i = 0; i < steps.length - 1; i++) {
        const a = steps[i],
          b = steps[i + 1];
        if (qty >= a.qty && qty <= b.qty) {
          const t = (qty - a.qty) / (b.qty - a.qty);
          return a.position + t * (b.position - a.position);
        }
      }
      return last.position;
    }

    function updateProgressbar(qty) {
      if (!steps.length) return;
      const pct = percentForQty(qty);
      steps.forEach((s) => s.el.classList.toggle("is-active", qty >= s.qty));
      if (pbFill) pbFill.style.width = pct + "%";
      if (pbDot) {
        pbDot.style.left = pct + "%";
        pbDot.style.opacity = qty > 0 ? "1" : "0";
      }

      const cur = currentStep(qty);
      const curQty = cur ? cur.qty : 0;
      detailTiers.forEach((t) => {
        t.classList.toggle("is-current", parseInt(t.dataset.tierQty, 10) === curQty && qty > 0);
      });
    }

    function updateInstigador(qty) {
      if (!instigadorEl) return;
      const next = nextBetterStep(qty);
      if (!next) {
        instigadorEl.textContent = instigadorMax;
        return;
      }
      const diff = next.qty - qty;
      const unit = diff === 1 ? singular : plural;
      let frete = next.freeShipping ? " + frete grátis" : "";
      instigadorEl.innerHTML =
        'Adicione <span class="cr-hl-primary">+' +
        diff +
        " " +
        unit +
        "</span> e destrave " +
        '<span class="cr-hl-accent">' +
        next.discount +
        "% OFF" +
        frete +
        "</span>";
    }

    function updatePreview(qty) {
      if (!previewEl) return;
      previewEl.innerHTML = "";
      let count = 0;
      getContainers().forEach((c) => {
        const input = c.querySelector(".monte-seu-kit-input-qty");
        const q = input ? parseInt(input.value, 10) || 0 : 0;
        if (q <= 0) return;
        count++;
        const item = document.createElement("div");
        item.className = "cr-preview-item";
        item.style.background = c.dataset.bgColor;
        const thumb = c.dataset.thumb;
        item.innerHTML =
          (thumb ? '<img src="' + thumb + '" alt="' + (c.dataset.name || "") + '" loading="lazy">' : "") +
          '<span class="cr-preview-qty">' +
          q +
          "</span>";
        previewEl.appendChild(item);
      });

      if (hasBrinde(qty)) {
        const gift = document.createElement("div");
        gift.className = "cr-preview-gift";
        const brindeInner = brindeImage
          ? '<img src="' + brindeImage + '" alt="Brinde" loading="lazy">'
          : '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M4 9h16v11H4V9Z" stroke="currentColor" stroke-width="1.6"/>' +
            '<path d="M2 6h20v3H2V6ZM12 6v14" stroke="currentColor" stroke-width="1.6"/>' +
            '<path d="M12 6S9 2 7 4s3 2 5 2 7 0 5-2-5 2-5 2Z" stroke="currentColor" stroke-width="1.4"/></svg>';
        gift.innerHTML =
          brindeInner +
          '<span class="cr-gift-badge"><svg width="10" height="10" viewBox="0 0 24 24" fill="none"><path d="M20 7 9 18l-5-5" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        previewEl.appendChild(gift);
        count++;
      }
      previewEl.hidden = count === 0;
      if (legendEl) {
        legendEl.hidden = count === 0;
        legendEl.textContent = textoSeuKit + " (" + qty + (qty === 1 ? " item)" : " itens)");
      }
    }

    /* Preço dos cards: exibe o valor com o desconto da faixa que seria atingida
       ao adicionar mais 1 item (a contagem soma potes iguais ou diferentes). */
    function updateCardPrices(qty) {
      const proximo = currentStep(qty + 1);
      const pct = proximo ? proximo.discount : 0;

      priceBlocks.forEach((block) => {
        const base = parseInt(block.dataset.basePrice, 10) || 0;
        const finalEl = block.querySelector("[data-price-final]");
        const originalEl = block.querySelector("[data-price-original]");
        const compareEl = block.querySelector("[data-price-compare]");
        if (!finalEl) return;

        if (pct > 0 && base > 0) {
          finalEl.textContent = formatarMoeda(Math.round((base * (100 - pct)) / 100));
          if (originalEl) {
            originalEl.textContent = formatarMoeda(base);
            originalEl.hidden = false;
          }
          // evita dois preços riscados lado a lado
          if (compareEl) compareEl.hidden = true;
          block.classList.add("tem-desconto-projetado");
        } else {
          finalEl.textContent = formatarMoeda(base);
          if (originalEl) originalEl.hidden = true;
          if (compareEl) compareEl.hidden = false;
          block.classList.remove("tem-desconto-projetado");
        }
      });
    }

    function updateSummary(state) {
      const disc = currentStep(state.qty);
      const discPct = disc ? disc.discount : 0;
      const totalCents = somaUnitaria([discPct]);
      const descontoCents = state.subtotal - totalCents;

      if (subtotalEl) subtotalEl.textContent = formatarMoeda(state.subtotal);
      if (summaryQtyEl) {
        summaryQtyEl.textContent = state.qty > 0 ? "(" + state.qty + " " + (state.qty === 1 ? singular : plural) + ")" : "";
      }
      if (discountLineEl && discountEl) {
        if (descontoCents > 0) {
          discountLineEl.hidden = false;
          discountEl.textContent = "- " + formatarMoeda(descontoCents);
          if (discountPctEl) discountPctEl.textContent = "(" + discPct + "% OFF)";
        } else {
          discountLineEl.hidden = true;
        }
      }
      if (totalKitEl) totalKitEl.textContent = formatarMoeda(totalCents || state.subtotal);
      if (buyTotalEl) buyTotalEl.textContent = formatarMoeda(totalCents || state.subtotal);

      // assinatura: mesmo arredondamento por unidade, com o desconto da
      // assinatura em cima do preço que já saiu com a faixa
      const subCents = somaUnitaria([discPct, subDesconto]);
      if (subCompareEl) subCompareEl.textContent = formatarMoeda(state.subtotal);
      if (subTotalEl) subTotalEl.textContent = formatarMoeda(subCents);
    }

    function calcTotal() {
      const state = getState();
      updateProgressbar(state.qty);
      updateInstigador(state.qty);
      updatePreview(state.qty);
      updateCardPrices(state.qty);
      updateSummary(state);

      const disabled = state.qty <= 0;
      [buyBtn, subscribeBtn, clearBtn].forEach((b) => {
        if (b) b.disabled = disabled;
      });
      if (errorEl) errorEl.hidden = true;
    }

    /* O accordion por coleção virou abas: quem troca de coleção agora é o
       <tab-nav> (assets/tab-nav.js), inclusive pelo teclado. Só sobra aqui a
       ponte com o editor de temas — selecionar o bloco de uma coleção na
       barra lateral tem que abrir a aba dela, senão o lojista clica no bloco
       e nada acontece na tela. */
    const abasMSK = root.querySelector("tab-nav");
    if (abasMSK) {
      document.addEventListener("shopify:block:select", function (e) {
        const aba = e.target.closest(".tab-nav__tab");
        if (!aba || !abasMSK.contains(aba) || typeof abasMSK.select !== "function") return;
        abasMSK.select(Array.from(abasMSK.querySelectorAll(".tab-nav__tab")).indexOf(aba));
      });
    }

    root.querySelectorAll("[data-msk-plus]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        const input = this.previousElementSibling;
        const container = this.closest("cart-update-monte-seu-kit");

        if (!input || !container) return;

        const estoque = parseInt(container.getAttribute("data-inventory")) || 999;
        let atual = parseInt(input.value) || 0;

        if (atual < estoque) {
          input.value = atual + 1;
          input.classList.remove("monte-seu-kit-zero");

          const minus = container.querySelector(".monte-seu-kit-minus");
          if (minus) {
            minus.classList.remove("monte-seu-kit-item-not-added");
          }

          calcTotal();
        }
      });
    });

    root.querySelectorAll("[data-msk-minus]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        const input = this.nextElementSibling;
        const container = this.closest("cart-update-monte-seu-kit");

        if (!input || !container) return;

        let atual = parseInt(input.value) || 0;

        if (atual > 0) {
          input.value = atual - 1;

          if (atual - 1 === 0) {
            input.classList.add("monte-seu-kit-zero");
            this.classList.add("monte-seu-kit-item-not-added");
          }

          calcTotal();
        }
      });
    });

    function buildItems(subscription) {
      const items = [];
      getContainers().forEach(function (container) {
        const id = container.getAttribute("data-variant");
        const input = container.querySelector(".monte-seu-kit-input-qty");
        const qtd = input ? parseInt(input.value, 10) || 0 : 0;
        if (qtd > 0 && id) {
          const item = { id: Number(id), quantity: qtd };
          if (subscription && sellingPlanId) item.selling_plan = sellingPlanId;
          items.push(item);
        }
      });
      // brinde opcional: permanece assim que qualquer faixa com brinde é atingida
      if (brindeVariantId && hasBrinde(getState().qty)) {
        items.push({ id: brindeVariantId, quantity: 1 });
      }
      return items;
    }

    function resetInputs() {
      getContainers().forEach(function (container) {
        const input = container.querySelector(".monte-seu-kit-input-qty");
        const minus = container.querySelector(".monte-seu-kit-minus");
        if (input) {
          input.value = 0;
          input.classList.add("monte-seu-kit-zero");
        }
        if (minus) minus.classList.add("monte-seu-kit-item-not-added");
      });
    }

    /* Limpar seleção: reaproveita o mesmo resetInputs do pós-checkout e devolve
       o módulo ao estado inicial (resumo, mini-carrinho, barra e CTAs). */
    if (clearBtn) {
      clearBtn.addEventListener("click", function (e) {
        e.preventDefault();
        resetInputs();
        calcTotal();
      });
    }

    async function adicionarAoCarrinho(subscription, btn) {
      const items = buildItems(subscription);
      if (!items.length) return;

      btn.classList.add("is-loading");
      btn.disabled = true;
      if (errorEl) errorEl.hidden = true;

      try {
        const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || "Não foi possível adicionar ao carrinho.");

        document.body.classList.remove("monte-seu-kit-aberto");
        document.body.classList.add("cart-sidebar-show");

        fetch(window.Shopify.routes.root + "cart.js")
          .then((r) => r.json())
          .then((cart) => {
            document.querySelectorAll("[data-cart-count]").forEach((el) => {
              el.textContent = cart.item_count;
            });
            if (typeof window.updateCart === "function") window.updateCart(cart);
          });

        resetInputs();
        calcTotal();
      } catch (error) {
        console.error("Erro:", error);
        if (errorEl) {
          errorEl.textContent = error.message;
          errorEl.hidden = false;
        }
      } finally {
        btn.classList.remove("is-loading");
        btn.disabled = false;
        calcTotal();
      }
    }

    if (buyBtn)
      buyBtn.addEventListener("click", function () {
        adicionarAoCarrinho(false, this);
      });
    if (subscribeBtn)
      subscribeBtn.addEventListener("click", function () {
        adicionarAoCarrinho(true, this);
      });

    calcTotal();

    function abrirCompraRapida() {
      document.body.classList.add("monte-seu-kit-aberto");
    }

    // Delegação: qualquer link com #monte-seu-kit no href (mesmo adicionado depois)
    document.addEventListener("click", function (e) {
      const link = e.target.closest('a[href*="#monte-seu-kit"]');
      const btn = e.target.closest("#monte-seu-kit-trigger");

      if (btn && !link) {
        e.preventDefault();
        abrirCompraRapida();
        return;
      }
      if (!link) return;

      const href = (link.getAttribute("href") || "").trim();
      // só intercepta se for a mesma página (ou link só de hash);
      // se apontar para outra página, deixa navegar e a página de destino abre no load
      const mesmaPagina = href.charAt(0) === "#" || link.pathname === window.location.pathname;

      if (mesmaPagina) {
        e.preventDefault();
        abrirCompraRapida();
      }
    });

    // Redirect de outra página: chega com #monte-seu-kit na URL
    if (window.location.hash === "#monte-seu-kit") {
      abrirCompraRapida();
      // limpa o hash pra não reabrir num refresh / manter o back button limpo
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    // Caso o hash mude sem recarregar a página
    window.addEventListener("hashchange", function () {
      if (window.location.hash === "#monte-seu-kit") {
        abrirCompraRapida();
      }
    });

    document.querySelectorAll("[fechar-monte-seu-kit]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        document.body.classList.remove("monte-seu-kit-aberto");
      });
    });

    const overlay = document.querySelector(".background-overlay");

    if (overlay) {
      overlay.addEventListener(
        "click",
        function (e) {
          document.body.classList.remove("monte-seu-kit-aberto");
        },
        true
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rating-video-gallery"] && !Shopify.designMode) return;
  try {
    
  function initRatingVideoGallery(root) {
    root = root || document;

    root.querySelectorAll(".rating-video-gallery-section").forEach(function (section) {
      if (section.dataset.rvgInitialized === "true") return;
      section.dataset.rvgInitialized = "true";

      var categorySelectors = section.querySelectorAll(".category-selector");
      var reviewItems = section.querySelectorAll(".review-item");
      var reviewsScroller = section.querySelector(".reviews-scroller .scrollable-container");

      function filterReviewsByIndex(index) {
        reviewItems.forEach(function (item) {
          item.hidden = item.dataset.index !== index;
        });

        if (reviewsScroller) {
          reviewsScroller.scrollLeft = 0;
          reviewsScroller.dispatchEvent(new Event("scroll"));
        }
      }

      categorySelectors.forEach(function (selector) {
        selector.addEventListener("click", function () {
          categorySelectors.forEach(function (el) {
            el.classList.remove("active");
          });
          selector.classList.add("active");
          filterReviewsByIndex(selector.dataset.index);
        });
      });

      var initialSelector = section.querySelector(".category-selector.active") || categorySelectors[0];
      if (initialSelector) {
        filterReviewsByIndex(initialSelector.dataset.index);
      }

      // Exibe a duração real do vídeo (mm:ss) assim que os metadados carregam
      section.querySelectorAll("video-gallery-element").forEach(function (slide) {
        var video = slide.querySelector("video");
        var durationBadge = slide.querySelector("[data-video-duration]");
        if (!video || !durationBadge) return;

        function setDuration() {
          if (!isFinite(video.duration)) return;
          var minutes = Math.floor(video.duration / 60);
          var seconds = Math.floor(video.duration % 60)
            .toString()
            .padStart(2, "0");
          durationBadge.textContent = minutes + ":" + seconds;
        }

        if (video.readyState >= 1) {
          setDuration();
        } else {
          video.addEventListener("loadedmetadata", setDuration, { once: true });
        }
      });
    });
  }

  function setupvideoslideobserver() {
    const slides = document.querySelectorAll("video-gallery-element");

    if (!slides.length) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return;

        const slide = mutation.target;
        const video = slide.querySelector("video");
        const btnPlay = slide.querySelector(".video-toggle-play");
        if (!video) return;

        const isActive = slide.classList.contains("swiper-slide-active");

        if (isActive) {
          // Became active → play
          video.muted = true; // for autoplay safety
          video.play();
          btnPlay?.classList.add("playing");
        } else {
          video.pause();
          btnPlay?.classList.remove("playing");
        }
      });
    });

    slides.forEach((slide) => {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  function playCenterVideo(swiper) {
    const swiperInstance = swiper ? swiper : document.querySelector(".rating-video-gallery.swiper").swiper;

    if (swiperInstance) {
      swiperInstance.slides.forEach((slideEl, index) => {
        const video = slideEl.querySelector("video");
        const btnPlay = slideEl.querySelector(".video-toggle-play");
        if (!video) return; // no video in this slide

        if (index === swiperInstance.activeIndex) {
          video.muted = true;
          video.play();
          btnPlay?.classList.add("playing");
        } else {
          video.pause();
          btnPlay?.classList.remove("playing");
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initRatingVideoGallery();

    // Em páginas sem blocos de vídeo (ex.: /pages/avaliacoes) não há carrossel para iniciar
    if (!document.querySelector(".rating-video-gallery")) return;

    const gallery = new Swiper(".rating-video-gallery", {
      slidesPerView: 1.25,
      spaceBetween: 10,
      slideToClickedSlide: false,
      loop: true,
      on: {
        init: function (swiper) {
          setupvideoslideobserver();
          playCenterVideo(swiper);
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        450: {
          slidesPerView: 1.4,
        },
        551: {
          slidesPerView: 2.08,
        },
        767: {
          slidesPerView: 2.8,
        },
        992: {
          slidesPerView: 3.4,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1400: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      },
    });
  });

  document.addEventListener("shopify:section:load", function (event) {
    initRatingVideoGallery(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-show"] && !Shopify.designMode) return;
  try {
    
  // Mantém a cor da divisória inferior sincronizada com o slide ativo do slideshow.
  class SlideshowDivider extends HTMLElement {
    connectedCallback() {
      this.slideshow = document.getElementById(this.dataset.slideshow);
      this.divider = this.querySelector("[data-bottom-wavy-divider]");
      if (!this.slideshow || !this.divider) return;

      this.fallbackColor = this.divider.style.getPropertyValue("--divider-color");
      this.sync = this.sync.bind(this);

      // O slick reescreve as classes dos slides a cada transição, e pode inicializar
      // depois deste elemento, então observar o DOM é mais confiável que ouvir seus eventos.
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.slideshow, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });

      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    sync() {
      const current =
        this.slideshow.querySelector(".item.slick-current") || this.slideshow.querySelector(".item");

      this.divider.style.setProperty(
        "--divider-color",
        (current && current.getAttribute("data-slide-bg")) || this.fallbackColor
      );
    }
  }

  if (!customElements.get("slideshow-divider")) {
    customElements.define("slideshow-divider", SlideshowDivider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  function setupvideoslideobserver() {
    const slides = document.querySelectorAll("video-gallery-element");

    if (!slides.length) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return;

        const slide = mutation.target;
        const video = slide.querySelector("video");
        const btnPlay = slide.querySelector(".video-toggle-play");
        if (!video) return;

        const isActive = slide.classList.contains("swiper-slide-active");

        if (isActive) {
          // Became active → play
          video.muted = true; // for autoplay safety
          video.play();
          btnPlay?.classList.add("playing");
        } else {
          video.pause();
          btnPlay?.classList.remove("playing");
        }
      });
    });

    slides.forEach((slide) => {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  function playCenterVideo(swiper) {
    const swiperInstance = swiper ? swiper : document.querySelector(".video-gallery.swiper").swiper;

    if (swiperInstance) {
      swiperInstance.slides.forEach((slideEl, index) => {
        const video = slideEl.querySelector("video");
        const btnPlay = slideEl.querySelector(".video-toggle-play");
        if (!video) return; // no video in this slide

        if (index === swiperInstance.activeIndex) {
          video.muted = true;
          video.play();
          btnPlay?.classList.add("playing");
        } else {
          video.pause();
          btnPlay?.classList.remove("playing");
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const gallery = new Swiper(".video-gallery", {
      slidesPerView: 1.25,
      spaceBetween: 10,
      slideToClickedSlide: false,
      loop: true,
      on: {
        init: function (swiper) {
          setupvideoslideobserver();
          playCenterVideo(swiper);
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        450: {
          slidesPerView: 1.4,
      slideToClickedSlide: false,
        },
        551: {
          slidesPerView: 2.08,
      slideToClickedSlide: false,
        },
        767: {
          slidesPerView: 2.8,
      slideToClickedSlide: false,
        },
        992: {
          slidesPerView: 3.4,
      slideToClickedSlide: false,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 10,
      slideToClickedSlide: false,
        },
        1400: {
          slidesPerView: 5,
          spaceBetween: 10,
      slideToClickedSlide: false,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
